import { NgModule } from '@angular/core';
import { SideSheetHeaderComponent } from './side-sheet-header.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [SideSheetHeaderComponent],
  exports: [SideSheetHeaderComponent]
})
export class SideSheetHeaderModule { }
